import { FieldDisplayData } from "../../components/dashboard/FieldDisplay";

export const toFieldDisplayData = (str: string | null | undefined, defaultKeyLabel: string): Array<FieldDisplayData<string>> => {
    return (str?.split("\n").filter(Boolean) ?? []).reduce((acc, line, index) => {
        if (line.includes(":")) {
            const [key, value] = line.split(":");
            acc.push({ label: key.trim(), data: value.trim() });
            return acc;
        }
        if (index === 0) {
            acc.push({ label: defaultKeyLabel, data: line.trim() });
            return acc;
        }
        const prev = acc[acc.length - 1];
        prev.data += `${prev.data ? "\n" : ""}${line.trim()}`;
        return acc;
    }, new Array<FieldDisplayData<string>>());
};